<template>
	<article class="req">
		<page-header :title="title">
			<p class="req__total">
				총 등록 ({{ total.total | currency }}) ㅣ 대기 ({{
					total.대기 | currency
				}}) ㅣ 반려 ({{ total.반려 | currency }}) ㅣ 보류 ({{
					total.보류 | currency
				}}) ㅣ 완료 ({{ total.완료 | currency }})
			</p>
		</page-header>
		<managing-section :is-table="true">
			<horizontal-search
				:block-elem="true"
				class="search-by-enter__container"
				@search="search"
				@init="initPage"
			>
				<select-input
					ref="searchType"
					:default-select-value="searchType"
					:select-list="searchTypeList"
					placeholder="입력하세요"
					@change="searchTypeChange"
				/>
				<select-input
					ref="date"
					:use-period="true"
					:default-select-value="date"
					:select-list="dateList"
					@change="dateChange"
				/>
			</horizontal-search>
		</managing-section>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<span class="section__info__left">
					검색결과: {{ totalItem | currency }}
				</span>
				<div class="section__info__right">
					<div class="section__info__items">
						<selector
							v-model="static_code"
							title="요청종류"
							:option-list="staticCodeList"
							@input="staticCodeChange"
						/>
					</div>
					<div class="section__info__items">
						<selector
							v-model="state"
							title="답변상태"
							:option-list="stateList"
							@input="search"
						/>
					</div>
					<div class="section__info__items">
						<selector
							v-model="adminAccount"
							title="관리자"
							:option-list="adminAccountList"
							@input="search"
						/>
					</div>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="req__table__no">No</th>
						<th class="req__table__date">접수일</th>
						<th class="req_tabel_brand">브랜드명</th>
						<th>제품명</th>
						<th>내용</th>
						<th class="req__table__register">문의자</th>
						<th class="req__table__state">답변 상태</th>
						<th class="req__table__date">답변일</th>
						<th class="req__table__admin">관리자</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td>
							<router-link
								:to="`/product/req/${item.cs_product.static_code}?cspId=${item.cs_product.id}`"
								class="link"
								>{{ item.cs_product.id }}</router-link
							>
						</td>
						<td>{{ item.createdAt }}</td>
						<td>{{ item.brandName || '-' }}</td>
						<td class="req__table__title">
							<router-link
								class="link"
								:to="
									static_code === 'CSP_01'
										? `/product/req/${item.cs_product.static_code}?cspId=${item.cs_product.id}`
										: `/product/product-inquiry/${item.product.idProduct}`
								"
								>{{
									item.cs_product.product_name ||
									item.product.productTitle ||
									'-'
								}}</router-link
							>
						</td>
						<td class="text-left req__table__content">
							<router-link
								:to="`/product/req/${item.cs_product.static_code}?cspId=${item.cs_product.id}`"
								class="link"
								>{{ item.cs_product.body || '-' }}</router-link
							>
						</td>
						<td class="text-left">
							<router-link
								:to="`/register/register-info/${item.cs_product.register_id}`"
								class="link"
								target="_blank"
								>{{ item.register.nickName }}</router-link
							>
						</td>
						<td>{{ item.cs_product.state || '대기' }}</td>
						<td>{{ item.updatedAt }}</td>
						<td class="req__table__admin">
							{{ item.adminAccount.nickName }}
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="totalItem"
				:limit="size"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
	</article>
</template>
<script>
	import moment from 'moment';
	import { mapState } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'ProductReqList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			Selector,
			PaginationBox,
		},
		extends: SearchByEnter,
		data() {
			return {
				total: {
					total: 0,
					대기: 0,
					반려: 0,
					보류: 0,
					완료: 0,
				},
				static_code: null,
				searchTypeList: [
					{ value: 'register', name: '문의자' },
					{ value: 'productTitle', name: '제품명' },
					{ value: 'keyword', name: '내용' },
					{ value: 'brandTitle', name: '브랜드명' },
				],
				searchType: 'register',
				register: '',
				productTitle: '',
				keyword: '',
				dateList: [
					{ value: 'in', name: '접수일' },
					{ value: 'out', name: '답변일' },
				],
				date: 'in',
				start_date: '',
				end_date: '',
				stateList: [
					{ value: null, name: '전체' },
					{ value: '대기', name: '대기' },
					{ value: '반려', name: '반려' },
					{ value: '보류', name: '보류' },
					{ value: '완료', name: '완료' },
				],
				state: null,
				adminAccountList: [],
				adminAccount: null,
				page: 1,
				size: 20,
				list: [],
				totalItem: 0,
			};
		},
		computed: {
			...mapState({
				staticCodes: state =>
					state.filter.staticCodes
						.filter(item => item.parent_code === 'CSP')
						.map(item => ({ value: item.code, name: item.name })),
			}),
			staticCodeList() {
				return [{ value: null, name: '전체' }, ...this.staticCodes];
			},
			title() {
				const code = this.static_code;
				const title = !code
					? '제품관련요청'
					: this.staticCodeList[
							this.staticCodeList.findIndex(
								item => item.value === code
							)
						].name;
				document.title = title;
				return title;
			},
			offset() {
				return (this.page - 1) * this.size;
			},
		},
		watch: {
			'$route.query'() {
				this.init();
			},
		},
		async mounted() {
			this.setTotal(this.$route.query.code);
			await this.setAdminAccount(this.$route.query.code);
			this.init();
		},
		methods: {
			async setAdminAccount(static_code) {
				const params = { static_code };
				const {
					data: { adminList },
				} = await this.$axiosSupport.get('/admin/cs/product/admin', {
					params,
				});
				this.adminAccountList = [
					{ value: null, name: '전체' },
					...adminList.map(item => ({
						value: item.idRegister,
						name: item.nickName,
					})),
				];
			},
			async setTotal(static_code) {
				const params = { static_code };
				const {
					data: { total },
				} = await this.$axiosSupport.get('/admin/cs/product/total', {
					params,
				});
				this.total = total;
			},
			setFilter() {
				const query = this.$route.query;
				if (query.page) this.page = Number(query.page);
				if (query.size) this.size = Number(query.size);
				const searchKeyObj = this.searchTypeList.find(
					({ value }) => query[value]
				);
				if (searchKeyObj) {
					const key = searchKeyObj.value;
					this.$refs.searchType.selectModel = this.searchType = key;
					this.$refs.searchType.inputModel = this[key] = query[key];
				}
				const setDate = (type, from, to) => {
					this.$refs.date.selectModel = this.date = type;
					this.$refs.date.changePeriod({
						from: from || '',
						to: to || '',
					});
				};
				if (query.in_start_date || query.in_end_date) {
					setDate('in', query.in_start_date, query.in_end_date);
				} else if (query.out_start_date || query.out_end_date) {
					setDate('out', query.out_start_date, query.out_end_date);
				}
				if (query.state) {
					this.state = query.state;
				}
				if (query.adminAccount) {
					this.adminAccount = Number(query.adminAccount);
				}
			},
			getParams() {
				const params = {
					page: this.page,
					size: this.size,
					static_code: this.static_code,
					state: this.state,
				};
				params[this.searchType] = this[this.searchType];
				if (this.start_date)
					params[`${this.date}_start_date`] = moment(this.start_date)
						.utc()
						.format();
				if (this.end_date)
					params[`${this.date}_end_date`] = moment(this.end_date)
						.utc()
						.format();
				if (this.adminAccount) params.adminAccount = this.adminAccount;
				return params;
			},
			setQuery() {
				const query = {
					page: String(this.page),
					size: String(this.size),
				};
				const searchType = this.searchType;
				if (this.static_code) query.code = this.static_code;
				if (this.state) query.state = this.state;
				if (this[searchType]) query[searchType] = this[searchType];
				if (this.start_date)
					query[`${this.date}_start_date`] = this.start_date;
				if (this.end_date)
					query[`${this.date}_end_date`] = this.end_date;
				if (this.adminAccount) query.adminAccount = this.adminAccount;
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			async getList() {
				const params = this.getParams();
				const { data } = await this.$axiosSupport.get(
					'/admin/cs/product',
					{ params }
				);
				this.totalItem = data.total_count;
				this.list = data.rows.map(item => {
					const updatedAt = moment(item.cs_product.updated_at);
					item.createdAt = moment(item.cs_product.created_at).format(
						'YYYY.MM.DD HH:mm:SS'
					);
					item.updatedAt =
						item.cs_product.state && updatedAt.isValid()
							? updatedAt.format('YYYY.MM.DD HH:mm:SS')
							: '-';
					item.brandName =
						params.static_code === 'CSP_01'
							? item.cs_product.brand_name
							: item.brand.name;
					return item;
				});
			},
			init() {
				this.static_code = this.$route.query.code || null;
				this.setFilter();
				this.getList();
			},
			initPage() {
				this.searchType = 'register';
				this.searchTypeList.forEach(({ value }) => {
					this[value] = '';
				});
				this.$refs.searchType.init();
				this.date = 'in';
				this.start_date = '';
				this.end_date = '';
				this.$refs.date.init();
				this.state = null;
				this.adminAccount = null;
				this.search();
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this[select] = input;
			},
			dateChange({ select, from, to }) {
				this.date = select;
				this.start_date = from;
				this.end_date = to;
			},
			search() {
				this.page = 1;
				this.setQuery();
			},
			paging({ offset }) {
				this.page = (offset + this.size) / this.size;
				this.setQuery();
			},
			async staticCodeChange(code) {
				this.setTotal(code);
				this.adminAccount = null;
				await this.setAdminAccount(code);
				this.search();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.req__total {
		line-height: 24px;
		font-size: 1rem;
	}

	.req__table__no {
		width: 90px;
	}

	.req__table__date {
		width: 160px;
	}

	.req_tabel_brand {
		width: 160px;
	}

	.req__table__title,
	.req__table__content {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.req__table__register {
		width: 150px;
	}

	.req__table__state {
		width: 80px;
	}

	.req__table__admin {
		width: 100px;
		padding: 0;
	}
</style>
